@if (initialized) {
  <div>
    <h1>Select bid item, material</h1>
    <div>
      @if (!filteredBidItems.length && !filteredMaterials.length) {
        <div class="mat-body-strong">
          No bid items, materials found for this project.
        </div>
      }
      <div class="cards-container">
        @for (material of filteredMaterials; track material) {
          <div class="stroked-card" (click)="onSelected(material)" [class.selected]="selectedEntity?.id === material.id">
            <div class="">{{material.name}}</div>
            <div class="">{{material.uom}}</div>
          </div>
        }
        @for (biditem of filteredBidItems; track biditem) {
          <div class="stroked-card" (click)="onSelected(biditem)" [class.selected]="selectedEntity?.id === biditem.id">
            <div class="">{{biditem.item}}</div>
            <div class="">{{biditem.uom}}</div>
            <div class="">{{biditem.unit_price}}</div>
            <div class="">{{biditem.description}}</div>
          </div>
        }
      </div>
    </div>
  </div>
}